import {
  init,
  login,
  loginFailed,
  loginRedirectBilling,
  loginRedirectConfirmation,
  loginSuccess,
  logoutSuccess,
  popFlash,
  setFlash,
  setSignature,
  setUserSessionData,
  toggleEmailPreviewSuccess,
  toggleHintsSuccess,
  toggleUnsubscribeSuccess,
  toggleVipFeatureSuccess,
  updateTimezone,
  vmsMessageLock,
} from '../actions/user.action';
import { Action, createReducer, on } from '@ngrx/store';
import { UserState } from '../models/user.model';

const initialState: UserState = {
  user: {
    id: null,
    name: null,
  },
  loggedIn: false,
  redirectRequired: false,
  sessionData: undefined,
  flashMessages: [],
  vsmLockMessageId: null,
};

const userReducer = createReducer(
  initialState,
  on(init, state => {
    const token = localStorage.getItem('token');
    return {
      ...initialState,
      flashMessages: [...(state.flashMessages || [])],
      loggedIn: !!token,
    };
  }),
  on(login, state => ({ ...state })),
  on(loginSuccess, (state, { accessToken }) => {
    return {
      ...state,
      redirectRequired: true,
      user: {
        ...state.user,
        id: accessToken.user_id,
      },
      loggedIn: true,
    };
  }),

  on(loginFailed, (state, { error }) => {
    return {
      ...state,
      redirectRequired: true,
      status: 'error',
      loggedIn: false,
      error,
    };
  }),

  on(loginRedirectBilling, (state, { username }) => {
    localStorage.setItem('email', username);

    return {
      ...state,
      redirectRequired: true,
      redirectTo: {
        route: 'register',
        params: {
          payment: true,
        },
      },
    };
  }),

  on(loginRedirectConfirmation, state => {
    return {
      ...state,
      redirectRequired: true,
      redirectTo: {
        route: 'register',
        params: {
          confirmation: true,
        },
      },
    };
  }),

  on(logoutSuccess, state => {
    return {
      ...state,
      redirectRequired: true,
      loggedIn: false,
    };
  }),

  on(setUserSessionData, (state, { data }) => {
    return {
      ...state,
      sessionData: data,
    };
  }),

  on(setSignature, (state, { signature }) => {
    return {
      ...state,
      sessionData: {
        ...state.sessionData,
        signature,
      },
    };
  }),

  on(setFlash, (state, { data }) => {
    return {
      ...state,
      flashMessages: [...(state.flashMessages || []), data],
    };
  }),

  on(popFlash, state => {
    const flashMessages = state.flashMessages;
    flashMessages.pop();
    return {
      ...state,
      flashMessages,
    };
  }),
  on(toggleEmailPreviewSuccess, (state, { value }) => {
    return {
      ...state,
      sessionData: {
        ...state.sessionData,
        emails_preview: value,
      },
    };
  }),
  on(toggleHintsSuccess, (state, action) => {
    return {
      ...state,
      sessionData: { ...state.sessionData, popup_tips: action.value },
    };
  }),
  on(toggleUnsubscribeSuccess, (state, action) => {
    return {
      ...state,
      sessionData: { ...state.sessionData, unsubscribe: action.value },
    };
  }),
  on(toggleVipFeatureSuccess, (state, action) => ({
    ...state,
    sessionData: { ...state.sessionData, vip_mode: action.value },
  })),
  on(updateTimezone, (state, action) => ({
    ...state,
    sessionData: { ...state.sessionData, time_zone: action.timezone },
  })),
  on(vmsMessageLock, (state, action) => ({
    ...state,
    vsmLockMessageId: action.messageId,
  })),
);

export function reducer(state: UserState | undefined, action: Action) {
  return userReducer(state, action);
}
